module.exports = __webpack_public_path__ + "static/media/rainy-7.c915395f.svg";